import { render, staticRenderFns } from "./AICreateTableButton.vue?vue&type=template&id=5402101a&scoped=true"
import script from "./AICreateTableButton.vue?vue&type=script&lang=js"
export * from "./AICreateTableButton.vue?vue&type=script&lang=js"
import style0 from "./AICreateTableButton.vue?vue&type=style&index=0&id=5402101a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402101a",
  null
  
)

export default component.exports